module.exports = __webpack_public_path__ + "static/hill1-7e72f1d3a07ae0d76bff5331553f3d7f.svg";